var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDownWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "9px",
    viewBox: "0 0 15 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9B6212C3-A31D-424A-A49D-90164ECDA943") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BackOffice",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home_Atendente-comercial_menu-2",
    transform: "translate(-165.000000, -121.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Menu",
    transform: "translate(0.000000, 87.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(92.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "next-(1)-copy-2",
    transform: "translate(73.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,8.8 L14.7,2 C14.9,1.8 14.9,1.6 14.9,1.4 C14.9,1.2 14.8,1 14.7,0.8 L14.2,0.3 C13.9,1.33226763e-15 13.4,1.33226763e-15 13,0.3 L7.5,6 L1.8,0.2 C1.7,0.1 1.5,0 1.3,0 C1,0 0.8,0.1 0.7,0.2 L0.2,0.7 C0,0.9 0,1.1 0,1.3 C0,1.5 0.1,1.7 0.2,1.9 L6.9,8.8 C7,8.9 7.2,9 7.5,9 C7.7,9 7.9,8.9 8,8.8 Z",
    id: "Path_1_"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/arrow-down-white.5e136658.svg";
export { ForwardRef as ReactComponent };